import axios from 'axios';
import { useQuery } from 'react-query';

export default function useFindIdCard(card) {
  const { data, isFetching, error } = useQuery(
      ['idCards', { tagId: card?.tagId }],
      async () => {
        return (await axios.get(`/idcards/byTagId/${card?.tagId}`)).data;
      },
      {
        enabled: card && card.tagId && !card.isFpso,
      }
  );

  return {
    idCard: data,
    isLoading: isFetching,
    error,
  };
}
